import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import GetForm from './ModalForm';
export const ReimbursementModal = observer(_ref => {
  let propertyAddress = _ref.propertyAddress,
    payoutData = _ref.payoutData,
    propertyId = _ref.propertyId,
    triggerReload = _ref.triggerReload;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      'custom-attribute': '300-ReimbursementModal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('general.edit'))),
    key: 'ReimbursementModal' + propertyId,
    title: t('subscriptions.edit_payment_option'),
    subTitle: propertyAddress,
    variant: "middle",
    noPadding: true,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      form: 'update_property_payout_details' + propertyId,
      id: "update_property_payout_details_submit_btn",
      fullWidth: true,
      type: "submit",
      disabled: store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress,
      'custom-attribute': '301-ReimbursementModal'
    }, t('buttons.save'))
  }, /*#__PURE__*/React.createElement(GetForm, {
    payoutData: payoutData,
    propertyId: propertyId,
    triggerReload: triggerReload
  }));
});